import * as empresa from '@/api/empresa'
import { convertSelect } from '../../../service/collection'

const state = {
  list: [],
  listaSelect: [],
  filtros: {nome: '', grupo: '', page: 1, active: true},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalDel: false,
  modalConfDel: false,
  modalConfDesativa: false
}

const mutations = {
  SETEMPRESAS (state, payload) {
    state.list = payload.list
  },
  SETEMPRESASSELECT (state, payload) {
    state.listaSelect = convertSelect(payload.list)
  },
  HIDDEMODAL (state) {
    state.modalAdd = false
    state.modalEdit = false
    state.modalConfDel = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALEDIT (state) {
    state.modalEdit = !state.modalEdit
  },
  MODALCONFDEL (state) {
    state.modalConfDel = !state.modalConfDel
  },
  MODALCONFDESATIVA (state) {
    state.modalConfDesativa = !state.modalConfDesativa
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  }
}

const actions = {
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalEdit: function ({ commit }) {
    commit('MODALEDIT')
  },
  modalConfDel: function ({ commit }) {
    commit('MODALCONFDEL')
  },
  modalConfDesativa: function ({commit}) {
    commit('MODALCONFDESATIVA')
  },
  async get ({ commit }, payload) {
    let data = await empresa.get(payload)
    return data
  },
  async getEmpresas ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await empresa.getEmpresas(payload)
    commit('SETEMPRESAS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getEmpresasSelect ({ commit }, payload) {
    let data = await empresa.getEmpresasSelect(Object.assign({}, payload, {active: true}))
    commit('SETEMPRESASSELECT', data)
  },
  async getEmpresasSelectUsuario ({ commit }, payload) {
    let data = await empresa.getEmpresasSelectUsuario(Object.assign({}, payload, { active: true }))
    commit('SETEMPRESASSELECT', data)
  },
  async getEmpresasSelectSemCommit ({ commit }, payload) {
    let data = await empresa.getEmpresasSelect(payload)
    return convertSelect(data.list)
  },
  async getEmpresasFiltro ({ commit, dispatch }) {
    let data = await empresa.getEmpresas(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETEMPRESAS', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async add ({ commit }, payload) {
    try {
      let reg = await empresa.add(payload)
      return reg.instancia
    } catch (e) {
      return e
    }
  },
  async edit ({ commit }, payload) {
    if (payload.grupo.value) {
      payload.grupo.id = payload.grupo.value
    }

    let reg = await empresa.edit(payload)
    return reg.instancia
  },
  async editStatus ({commit}, payload) {
    return empresa.editStatus(payload)
  },
  async delEmpresa ({ commit }, payload) {
    try {
      let retorno = await empresa.delEmpresa(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getEmpresas', state.filtros)
  },
  async getEmpresaLogin ({commit}, payload) {
    return empresa.getEmpresaLogin(payload)
  },
  async getEmpresasSelectRelatorioSemCommit ({ commit }, payload) {
    let data = await empresa.getEmpresasRelatorioSelect(payload)
    return convertSelect(data.list)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/empresa.js